import React, { useEffect } from "react";
import _ from "lodash";
import { motion } from "framer-motion/dist/framer-motion";
import theyEye from "assets/images/ct/they-know-eye.png";
import twoDice from "assets/images/ct/two-dice.png";
import disLine from "assets/images/ct/dis-line.png";
import {
  divVariants,
  fadeVariants,
  staticBounceVariants
} from "shared/components/animations";
const DiscoverySingleCommon = ({
  titleText = "",
  text1 = "",
  text2 = "",
  buttonText = "",
  buttonPress = () => {},
  categoryImage,
  isDiscardPileEmpty,
  diceValue = () => {},buzzer_sound,default_audio_effect
}) => {
  useEffect(() => {
    if (  !_.isEmpty(default_audio_effect)) {
      buzzer_sound();
    }
  }, [buzzer_sound, default_audio_effect]);
  return (
    <motion.div
      variants={divVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
      className="discovery-main"
    >
      <div className="discovery">
        <motion.div variants={fadeVariants} className="dis-top">
          <div className="dis-text">
            <img src={theyEye} className="img-fluid" alt="" />
            <div className="text-right">
              <img src={diceValue} className="img-fluid" alt="" />
              <h4>{titleText}</h4>
              <img src={disLine} className="img-fluid disLine" alt="" />
            </div>
          </div>
          <p className="desc">{text1}</p>
          <p className="desc">{text2}</p>
        </motion.div>
        <motion.div variants={staticBounceVariants} className="text-center">
          {isDiscardPileEmpty && (
            <img src={categoryImage} className="img-fluid mb-3" alt="" />
          )}
          <button className="ct-btn-green end-btn" onClick={buttonPress}>
            {buttonText}
          </button>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default DiscoverySingleCommon;
